import { z } from 'zod';
/** Machine-readable error codes shared by server and web. */
export const ErrorCodeSchema = z.enum([
    'bad_request',
    'validation_failed',
    'unauthorized',
    'forbidden',
    'not_found',
    'conflict',
    'rate_limited',
    'machine_offline',
    'machine_error',
    'not_configured',
    'needs_token',
    'upstream_error',
    'internal_error',
]);
export const ErrorDetailSchema = z.object({ path: z.string(), message: z.string() });
/** The envelope every failing /api/v1 response uses. */
export const ErrorBodySchema = z.object({
    error: z.object({
        code: ErrorCodeSchema,
        message: z.string(),
        details: z.array(ErrorDetailSchema).optional(),
    }),
});
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    db: z.enum(['ok', 'error']),
});
//# sourceMappingURL=api.js.map